import { useState } from "react";
import Button from "../../../../../components/Buttons/Button";
import { CustomSelectsOption } from "../../../../../components/Inputs/Selects/CustomSelect";
import CustomSelectOptionList from "../../../../../components/Inputs/Selects/CustomSelectOptionList";
import MultiSelectOptionsList from "../../../../../components/Inputs/Selects/MultiSelectOptionList";
import { IFilterInputs } from "./FilterInputs";
import { MdClose, MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

interface PropsFilterInputsSideBar extends IFilterInputs {
    onCloseSideBar: () => void;
    setHaveChanges: React.Dispatch<React.SetStateAction<boolean>>;
    haveChanges: boolean;
}

const FiltersInputsSideBar = ({
    variables,
    typeOfGraph,
    handleSelectVariable,
    selectedVariables,
    handleSelectMultipleVariables,
    areFiltersModified,
    handleCleanFilters,
    onCloseSideBar,
    haveChanges,
    setHaveChanges
}: PropsFilterInputsSideBar) => {
    const [openSections, setOpenSections] = useState<Record<string, boolean>>({});

    const toggleSection = (name: string) => {
        setOpenSections(prev => ({
            ...prev,
            [name]: !prev[name]
        }));
    };

    const handleClick = (label: string, option: CustomSelectsOption) => {
        if (handleSelectVariable.length > 1) {
            handleSelectVariable(label, option.value);
        } else {
            handleSelectVariable(option.value);
        }
    };

    return (
        <>
            <div className="px-4 py-6 flex justify-between">
                <p className="text-tmedium text-primary-10 ">FILTRAR</p>
                <button onClick={onCloseSideBar}><MdClose size={24} color="#001F29" /></button>
            </div>
            <div className="w-full overflow-y-auto h-[calc(100%-72px)]">
                {variables.length > 0 &&
                    variables.map((variable) => {
                        const isOpen = openSections[variable.name] ?? false;
                        return (
                            <div className={`flex flex-col border-t border-t-system-light-20 ${isOpen ? 'mb-4' : ''}`} key={variable.name}>
                                <div
                                    className="flex items-center justify-between rounded-md py-2 px-4"
                                    onClick={() => toggleSection(variable.name)}
                                >
                                    <div className="w-full">
                                        <div className="flex items-center justify-between gap-2">
                                            <span className="text-llarge text-system-light-40">{variable.name}</span>
                                            {isOpen ? <MdKeyboardArrowUp size={18} /> : <MdKeyboardArrowDown size={18} />}
                                        </div>
                                        {!isOpen && (
                                            <p className='whitespace-wrap text-lmedium text-secondary-10 w-full'>
                                                {selectedVariables[variable.name]?.includes('Todos')
                                                    ? 'Todos'
                                                    : selectedVariables[variable.name]?.join(', ')
                                                }
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {isOpen && (
                                    typeOfGraph === 6 || typeOfGraph === 7 ? (
                                        <CustomSelectOptionList
                                            options={variable.values}
                                            selectedItem={selectedVariables[variable.name]?.[0] || ''}
                                            handleClick={(option) => handleClick(variable.name, option)}
                                            className="bg-primary-100 px-4  overflow-scroll max-h-[225px]"
                                        />
                                    ) : (
                                        <MultiSelectOptionsList
                                            options={variable.values}
                                            selectedItems={(selectedVariables[variable.name] || []).map(value => ({
                                                value,
                                                label: variable.name,
                                            }))}
                                            onSelect={(option) => handleSelectMultipleVariables({ label: variable.name, value: option.value })}
                                            className="bg-primary-100 px-4 overflow-scroll max-h-[225px]"
                                        />
                                    )
                                )}
                            </div>
                        );
                    })}

                <div className="flex gap-2 justify-end px-4 py-4 absolute bottom-0 w-full bg-primary-100">
                    <Button
                        label='Limpiar filtros'
                        type='button'
                        showIconLeft={false}
                        showIconRight={false}
                        className={`text-primary-40 bg-primary-100 ${!areFiltersModified() ? 'opacity-50' : ''}`}
                        onClick={handleCleanFilters}
                        disabled={!areFiltersModified()}
                    />
                    {/* Solo sirve de UI */}
                    <Button
                        label='Aplicar filtro'
                        type='button'
                        showIconLeft={false}
                        showIconRight={false}
                        className='bg-primary-40 text-primary-100'
                        disabled={!haveChanges}
                        onClick={() => {
                            setHaveChanges(false);
                            onCloseSideBar();
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default FiltersInputsSideBar;